import React, { PureComponent, Fragment } from 'react';
import { array, func } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import DialogModal from '../../modals/DialogModal/DialogModal';
import StatisticsPresetsListItem from './StatisticsPresetsListItem';

class StatisticsPresetsList extends PureComponent {
  static propTypes = {
    presets: array.isRequired,
    onSelect: func.isRequired,
    onRemove: func.isRequired,
    intl: intlShape.isRequired,
  };

  state = {
    modal: false,
    id: 0,
  };

  selectPreset = (id) => {
    this.props.onSelect(id);
  };

  removePreset = (id) => {
    this.setState(() => ({ id, modal: true }));
  };

  onConfirm = () => {
    const { id } = this.state;
    this.setState({ modal: false, id: 0 });
    this.props.onRemove(id);
  };

  onCancel = () => {
    this.setState(() => ({ modal: false }));
  };

  getEmptyPresetProps = () => {
    const { intl } = this.props;
    return {
      id: 0,
      filter: {},
      title: intl.formatMessage({
        id: 'statistics.filters.presets.empty-preset',
        defaultMessage: 'Select Filter',
      }),
    };
  };

  render() {
    const { modal } = this.state;
    const { presets } = this.props;
    return (
      <Fragment>
        <ul className="statistics-presets-list list-unstyled no-margin">
          {presets.length === 0 ? (
            <li className="statistics-presets-empty">
              <FormattedMessage id="statistics.filters.presets.empty" defaultMessage="No filters" />
            </li>
          ) : (
            <StatisticsPresetsListItem
              key="0"
              onSelect={this.selectPreset}
              onRemove={this.removePreset}
              {...this.getEmptyPresetProps()}
            />
          )}

          {presets.map((preset) => (
            <StatisticsPresetsListItem
              key={preset.id}
              onSelect={this.selectPreset}
              onRemove={this.removePreset}
              {...preset}
            />
          ))}
        </ul>

        <DialogModal
          className="statistics-presets-modal"
          open={modal}
          title={
            <FormattedMessage
              id="statistics.preset.remove-confirmation-title"
              defaultMessage="Remove filter?"
            />
          }
          message={
            <FormattedMessage
              id="statistics.preset.remove-confirmation"
              defaultMessage="Remove preset?"
            />
          }
          onConfirm={this.onConfirm}
          onCancel={this.onCancel}
          cancelText={<FormattedMessage id="sources.modal.cancel" defaultMessage="Cancel" />}
          confirmText={<FormattedMessage id="sources.modal.confirm" defaultMessage="Remove" />}
        />
      </Fragment>
    );
  }
}

export default injectIntl(StatisticsPresetsList);
